// extracted by mini-css-extract-plugin
module.exports = {"informationSection":"Information_informationSection__EWtIE","content":"Information_content__0WCkP","block":"Information_block__uZGHC"};